/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable no-unused-vars */
import React, { useContext } from 'react';
import { TextField, Box, Button } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers';
import Grid from '@mui/material/Unstable_Grid2';
import moment from 'moment';
import { toast } from 'react-toastify';
// Context
import useClientCallOutDashboard from '../context/useClientCallOutDashboard';

export default function Filter() {
  const { filterForm, setFilterForm, handleGenerateFilter, handleClearFilter } =
    useContext(useClientCallOutDashboard);

  const handleChangeFrom = (value) => {
    setFilterForm({ ...filterForm, month_year: moment(value).format('YYYY-MM') });
  };

  return (
    <Box>
      <Grid container spacing={2}>
        <Grid md={2}>
          <DatePicker
            label='month_year'
            views={['month', 'year']}
            value={filterForm?.month_year}
            // eslint-disable-next-line react/jsx-props-no-spreading
            renderInput={(params) => (
              <TextField {...params} label='Month Year' size='small' fullWidth />
            )}
            onChange={(value) => handleChangeFrom(value)}
          />
        </Grid>
        <Grid md={2}>
          <Button variant='contained' color='success' onClick={handleGenerateFilter}>
            Generate
          </Button>
          <Button
            variant='contained'
            color='primary'
            onClick={() => handleClearFilter()}
            sx={{ marginLeft: '10px' }}
          >
            Clear
          </Button>
        </Grid>
      </Grid>
    </Box>
  );
}
